module.exports = "/_next/static/images/newsletter-fff000d5bff2961c2d9e0304652ac2ff.jpg";